import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'sonner';
import { AuthProvider } from './context/AuthContext';
import Navigation from './components/Navigation';
import HomePage from './pages/HomePage';
import AnonymousPage from './pages/AnonymousPage';
import ChatPage from './pages/ChatPage';
import RequestSongPage from './pages/RequestSongPage';
import LoginPage from './pages/AuthPages';
import AdminPage from './pages/AdminPage';
import SponsorPage from './pages/SponsorPage';
import RoomActionPage from './pages/RoomActionPage';
import SpotlightPage from './pages/SpotlightPage';
import ProtectedRoute from './components/auth/ProtectedRoute';
import './App.css';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <AuthProvider>
          <Toaster position="top-center" richColors theme="dark" />
          <Navigation />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/chat" element={<ChatPage />} />
            <Route path="/anonymous" element={<Navigate to="/chat" replace />} />
            <Route path="/request-song" element={<RequestSongPage />} />
            <Route path="/sponsor" element={<SponsorPage />} />
            <Route path="/pop-your-opp" element={<RoomActionPage actionType="pop_your_up" />} />
            <Route path="/gu-them" element={<RoomActionPage actionType="gu_them" />} />
            <Route path="/one-mic-individual" element={<RoomActionPage actionType="one_mic_individual" />} />
            <Route path="/one-mic-man-or-woman" element={<RoomActionPage actionType="one_mic_group" />} />
            <Route path="/come-back-from-the-gu" element={<RoomActionPage actionType="come_back_goo" />} />
            <Route path="/come-back-from-being-popped" element={<RoomActionPage actionType="come_back_popped" />} />
            <Route path="/spotlight" element={<SpotlightPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/admin" element={<ProtectedRoute><AdminPage /></ProtectedRoute>} />
            <Route path="*" element={
              <div className="min-h-screen flex items-center justify-center bg-black">
                <div className="text-center">
                  <h1 className="font-display text-4xl font-bold text-white mb-2">404</h1>
                  <p className="text-white/40 text-sm mb-6">Page not found</p>
                  <a href="/" className="btn-pink !text-xs">Back to Home</a>
                </div>
              </div>
            } />
          </Routes>
        </AuthProvider>
      </Router>
    </HelmetProvider>
  );
}

export default App;
